import React from 'react';
import cn from 'bem-cn';

import promptsImage from '../../images/prompts.png';

import { RoutePaths } from '../../constants';
import { Icon, Link, ImageWithFadeIn } from '../UI';

import './NewPromptBanner.scss';

const b = cn('new-prompt-banner');

export const NewPromptBanner: React.FC = () => {
    return (
        <Link to={RoutePaths.NewPrompt} className={b()}>
            <ImageWithFadeIn src={promptsImage} alt="" className={b('image')} />
            <div className={b('icon')}>
                <Icon name="plus" size={24} />
            </div>
            <div className={b('text')}>Придумайте новый промпт и поделитесь им со всеми пользователями</div>
        </Link>
    );
};
